import { NotificationsService } from '../services/notifications.service'
import {
    ExportExcelChatParams,
    ExportExcelParams,
    ExportExcelResponse,
    GetWhatsappChatMessagesParams,
    GetWhatsappChatMessagesResponse,
    GetWhatsappChatsParams,
    GetWhatsappChatsResponse,
    NotificationPayloadT,
    NotificationsGetListResponseT,
    NotificationsGetTypesResponseT,
} from '../types/notifications.types'

const notificationsService = new NotificationsService()

class NotificationsRealisation {
    getNotificationsList(params: any): Promise<NotificationsGetListResponseT> {
        return notificationsService.getNotificationsList(params)
    }

    createNotification(payload: NotificationPayloadT): Promise<void> {
        return notificationsService.createNotification(payload)
    }

    getNotificationsTypes(params: any): Promise<NotificationsGetTypesResponseT> {
        return notificationsService.getNotificationsTypes(params)
    }

    setDeviceToken(token: string): Promise<void> {
        return notificationsService.setDeviceToken(token)
    }

    readNotification(notification_id: number | string): Promise<void> {
        return notificationsService.readNotification(notification_id)
    }

    getWhatsappChats(params: GetWhatsappChatsParams): Promise<GetWhatsappChatsResponse> {
        return notificationsService.getWhatsappChats(params)
    }

    getWhatsappChatMessages(
        params: GetWhatsappChatMessagesParams
    ): Promise<GetWhatsappChatMessagesResponse> {
        return notificationsService.getWhatsappChatMessages(params)
    }

    exportExcel(params: ExportExcelParams): Promise<ExportExcelResponse> {
        return notificationsService.exportExcel(params)
    }

    exportExcelChat(params: ExportExcelChatParams): Promise<ExportExcelResponse> {
        return notificationsService.exportExcelChat(params)
    }
}

export const notifications_realisation = new NotificationsRealisation()
